import styleInject from './../../__node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "._MybA0{font-size:14px}._qlhZ4{color:#515559;line-height:20px;display:inline-flex;flex-direction:column;align-items:flex-start}._EBL1I{color:#0b6ed0}";
var styles = {"label":"_MybA0","control":"_qlhZ4","focused":"_EBL1I"};
var stylesheet="._MybA0{font-size:14px}._qlhZ4{color:#515559;line-height:20px;display:inline-flex;flex-direction:column;align-items:flex-start}._EBL1I{color:#0b6ed0}";
if(typeof process !== 'object' || !process.hasOwnProperty('env') || process.env.NODE_ENV !== 'test'){styleInject(css_248z);}

export { styles as default, stylesheet };
